type TextFormat = {
  extension: string;
  mimeType: string;
};

const HTML_TAG_PATTERN =
  /<(?:html|head|body|div|span|p|h[1-6]|ul|ol|li|table|tr|td|th|a|img|br|hr|form|input|button|section|article|nav|header|footer|main|aside)\b/i;

const MARKDOWN_PATTERNS: RegExp[] = [
  /^#{1,6}\s/m,
  /\*\*[^*]+\*\*/,
  /\[.+?\]\(.+?\)/,
  /^[-*+]\s/m,
  /^\d+\.\s/m,
  /^```/m,
  /^>\s/m,
  /^---$/m,
];

const MARKDOWN_MATCH_THRESHOLD = 2;

function detectTextFormat(text: string): TextFormat {
  if (HTML_TAG_PATTERN.test(text)) {
    return { extension: "html", mimeType: "text/html" };
  }

  const markdownMatches = MARKDOWN_PATTERNS.filter((p) => p.test(text)).length;
  if (markdownMatches >= MARKDOWN_MATCH_THRESHOLD) {
    return { extension: "md", mimeType: "text/markdown" };
  }

  return { extension: "txt", mimeType: "text/plain" };
}

function slugFromUrl(url: string): string {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, "");
    const path = parsed.pathname
      .replace(/\/+$/, "")
      .split("/")
      .filter(Boolean)
      .slice(-2)
      .join("-");
    const base = path ? `${host}-${path}` : host;
    return base.replace(/[^a-zA-Z0-9._-]/g, "-").slice(0, 80);
  } catch {
    return "url";
  }
}

export function createFileFromText(
  text: string,
  source: "pasted" | "typed" | "url" = "pasted",
  sourceUrl?: string
): File {
  const { extension, mimeType } = detectTextFormat(text);
  const name =
    source === "url" && sourceUrl
      ? slugFromUrl(sourceUrl)
      : `${source}-${crypto.randomUUID().slice(0, 8)}`;
  const fileName = `${name}.${extension}`;
  return new File([text], fileName, { type: mimeType });
}
